import '../Shared/common.scss';
import { InputLabel, OutlinedInput, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";

const TermInput = ({
    control,
    label,
    rules,
    name = "term",
    symbol = "months",
    size = "medium",
}: any & {
    control?: any;
    label?: string;
    rules?: any;
    name?: string;
    symbol?: string;
    size?: string;
}) => {

    return (
        <>
            <Controller
                name={name}
                control={control}
                rules={rules}
                key="term-controller"
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                    formState,
                }) => (
                    <>
                        <InputLabel htmlFor="term" key="term-label">{label}</InputLabel>
                        <OutlinedInput
                            id="term"
                            key="term-input"
                            endAdornment={<InputAdornment key="term-label2" position="end"><span className='small'>{symbol}</span></InputAdornment>}
                            name={name}
                            label={label}
                            value={value}
                            type='number'
                            onChange={onChange}
                            inputProps={{
                                min: 12, max: 60, style: { textAlign: 'right' }
                            }}
                            size={size}
                        />
                    </>

                )}
            />
        </>
    );
};

export default TermInput;
